import { render, staticRenderFns } from "./multiple-correct.vue?vue&type=template&id=3eed77a4&scoped=true&"
import script from "./multiple-correct.vue?vue&type=script&lang=js&"
export * from "./multiple-correct.vue?vue&type=script&lang=js&"
import style0 from "./multiple-correct.vue?vue&type=style&index=0&id=3eed77a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eed77a4",
  null
  
)

export default component.exports